import { render, staticRenderFns } from "./Telefone.vue?vue&type=template&id=5429f9ea"
import script from "./Telefone.vue?vue&type=script&lang=js"
export * from "./Telefone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports